import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import './css/main.scss';
import { BrowserRouter, Routes, 
  Route } from "react-router-dom";
import Layout from './layouts/layout';
import Lessons from './lessons';
import Nigel from './nigel';
import Home from './home';
import About from './about';
import Dream from './dream';
import Fundamentals from './fundamentals';
import Recommendations from './recommendations';
import Guitarcenter from './guitarcenter';
import Levels from './levels';
import More from './more';
import Theory from './theory';
import Search from './search';
import Booking from './booking';
import Login from './body/Login';
import Portal from './body/Portal';
import Privacy from './body/Privacy';
import PrivateRoute from './components/secureRoute';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />} >
        <Route path="/login" element={<Login />} />
          <Route path="/Portal" element={<PrivateRoute><Portal /></PrivateRoute>} />
          <Route path="/Lessons" element={<PrivateRoute><Lessons /></PrivateRoute>} />
          <Route path="/Nigel" element={<PrivateRoute><Nigel /></PrivateRoute>} />
          <Route path="/Booking" element={<Booking />} />
          <Route path="/About" element={<About />} />
          <Route path="/Dream" element={<Dream />} />
          <Route path="/Fundamentals" element={<Fundamentals />} />
          <Route path="/Recommendations" element={<Recommendations />} />
          <Route path="/Guitarcenter" element={<Guitarcenter />} />
          <Route path="/Levels" element={<Levels />} />
          <Route path="/More" element={<More />} />
          <Route path="/Theory" element={<Theory />} />
          <Route path="/Privacy" element={<Privacy />} />
          <Route path="/Search/:query" Component={Search} />          
          <Route index element={<Home />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;